/* Sucker Punch affiliate page. No dependencies. Plain script (loaded with <script defer src>), no import(). */
(function () {
  var root = document.querySelector('[data-spa]');
  if (!root) return;
  var API = root.getAttribute('data-api') || '';
  var SITE = root.getAttribute('data-site') || location.origin;
  var q = new URLSearchParams(location.search);
  var code = (q.get('c') || '').toUpperCase(), tok = q.get('t') || '';
  var $ = function (s) { return root.querySelector(s); };
  var money = function (n) { return '$' + Number(n || 0).toFixed(2); };

  function render(d) {
    $('[data-in]').hidden = false; $('[data-out]').hidden = true;
    $('[data-code]').textContent = d.code;
    $('[data-link]').value = SITE + '/discount/' + d.code + '?redirect=/pages/join';
    $('[data-pending]').textContent = money(d.earnings.pending);
    $('[data-approved]').textContent = money(d.earnings.approved + d.earnings.inPayout);
    $('[data-paid]').textContent = money(d.earnings.paid);
    $('[data-state]').textContent = d.payout.set ? 'Payouts go to ' + d.payout.email + ' (' + d.payout.method + ').' : 'Add where to send your money below.';
  }
  function msg(t, err) { var m = $('[data-msg]'); m.textContent = t; m.classList.toggle('is-err', !!err); }

  if (code && tok) {
    fetch(API + '?c=' + encodeURIComponent(code) + '&t=' + encodeURIComponent(tok))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(render)
      .catch(function () { $('[data-out]').hidden = false; $('[data-bad]').hidden = false; });
  } else { $('[data-out]').hidden = false; }

  $('[data-copy]').addEventListener('click', function () {
    var el = $('[data-link]'); el.select();
    (navigator.clipboard ? navigator.clipboard.writeText(el.value) : Promise.resolve(document.execCommand('copy')))
      .then(function () { $('[data-copy]').textContent = 'Copied'; setTimeout(function () { $('[data-copy]').textContent = 'Copy link'; }, 1800); });
  });

  $('[data-payform]').addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-save]'); btn.disabled = true; msg('Saving...');
    fetch(API, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({
      c: code, t: tok, paypal_email: $('[name=paypal_email]').value, method: $('[name=method]').value, agree: $('[name=agree]').checked }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        btn.disabled = false;
        if (!x.ok) return msg(x.j.error === 'bad_email' ? 'That email does not look right.' : x.j.error === 'terms_required' ? 'Tick the box to accept the terms.' : 'Could not save. Try again.', true);
        render(x.j); msg('Saved. We pay out every ' + (root.getAttribute('data-payday') || 'Friday') + '.');
      }).catch(function () { btn.disabled = false; msg('Could not save. Try again.', true); });
  });

  var rf = $('[data-resend]');
  if (rf) rf.addEventListener('submit', function (e) {
    e.preventDefault();
    fetch(API.replace(/portal$/, 'resend'), { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email: rf.querySelector('input').value }) })
      .finally(function () { $('[data-resend-msg]').textContent = 'If that email has an order, your link is on its way.'; });
  });
})();
